import axios from "axios";
import { authService } from "./authService.js";
class ApoderadosService {
    constructor() {
        Object.defineProperty(this, "baseURL", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        /**
         * Obtiene los apoderados principales de un curso específico
         */
        Object.defineProperty(this, "getMainGuardiansByCourse", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (schoolId, year, code) => {
                try {
                    const token = authService.getToken();
                    if (!token) {
                        throw new Error("No hay token de autenticación");
                    }
                    const response = await axios.get(`${this.baseURL}/apoderados?op=getMainGuardiansByCourse&school_id=${schoolId}&year=${year}&code=${code}`, {
                        headers: {
                            Authorization: token,
                        },
                    });
                    return response.data;
                }
                catch (error) {
                    console.error("Error obteniendo apoderados:", error);
                    throw error;
                }
            }
        });
        Object.defineProperty(this, "getGuardianWithCourses", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async () => {
                try {
                    const token = authService.getToken();
                    if (!token) {
                        throw new Error("No hay token de autenticación");
                    }
                    const response = await axios.get(`${this.baseURL}/apoderados?op=getGuardianWithCourses`, {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: token,
                        },
                    });
                    return response.data;
                }
                catch (error) {
                    console.error("Error obteniendo datos del apoderado:", error);
                    throw error;
                }
            }
        });
        Object.defineProperty(this, "updateGuardianWithCourses", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (payload) => {
                const token = authService.getToken();
                if (!token)
                    throw new Error("No hay token de autenticación");
                const response = await axios.post(`${this.baseURL}/apoderados?op=updateGuardianWithCourses`, payload, {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: token,
                    },
                });
                return response.data;
            }
        });
        Object.defineProperty(this, "createUserDocumentUpload", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (payload) => {
                const token = authService.getToken();
                if (!token)
                    throw new Error("No hay token de autenticación");
                const response = await axios.post(`${this.baseURL}/apoderados?op=createUserDocumentUpload`, payload, { headers: { Authorization: token } });
                return response.data;
            }
        });
        Object.defineProperty(this, "completeUserDocumentUpload", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (payload) => {
                const token = authService.getToken();
                if (!token)
                    throw new Error("No hay token de autenticación");
                const response = await axios.post(`${this.baseURL}/apoderados?op=completeUserDocumentUpload`, payload, { headers: { Authorization: token } });
                return response.data;
            }
        });
        Object.defineProperty(this, "getUserDocument", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (type = "INHABILITIES_CERTIFICATE", extra) => {
                const token = authService.getToken();
                if (!token)
                    throw new Error("No hay token de autenticación");
                const query = new URLSearchParams({
                    op: "getUserDocument",
                    type,
                });
                if (extra?.for_email)
                    query.set("for_email", extra.for_email);
                if (extra?.school_id)
                    query.set("school_id", extra.school_id);
                if (extra?.year)
                    query.set("year", extra.year);
                if (extra?.course_code)
                    query.set("course_code", extra.course_code);
                const response = await axios.get(`${this.baseURL}/apoderados?${query.toString()}`, { headers: { Authorization: token } });
                return response.data;
            }
        });
        Object.defineProperty(this, "deleteUserDocument", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (type = "INHABILITIES_CERTIFICATE", extra) => {
                const token = authService.getToken();
                if (!token)
                    throw new Error("No hay token de autenticación");
                const response = await axios.post(`${this.baseURL}/apoderados?op=deleteUserDocument`, { type, ...extra }, { headers: { Authorization: token } });
                return response.data;
            }
        });
        Object.defineProperty(this, "updateExtraGuardian", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (payload) => {
                const token = authService.getToken();
                if (!token)
                    throw new Error("No hay token de autenticación");
                const response = await axios.post(`${this.baseURL}/apoderados?op=updateExtraGuardian`, payload, { headers: { Authorization: token } });
                return response.data;
            }
        });
        Object.defineProperty(this, "sendExtraGuardianAccessEmail", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (payload) => {
                const token = authService.getToken();
                if (!token)
                    throw new Error("No hay token de autenticación");
                const response = await axios.post(`${this.baseURL}/apoderados?op=sendExtraGuardianAccessEmail`, payload, { headers: { Authorization: token } });
                return response.data;
            }
        });
        Object.defineProperty(this, "verifyUserDocument", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (type = "INHABILITIES_CERTIFICATE") => {
                const token = authService.getToken();
                if (!token)
                    throw new Error("No hay token de autenticación");
                const response = await axios.post(`${this.baseURL}/apoderados?op=verifyUserDocument`, { type }, { headers: { Authorization: token } });
                return response.data;
            }
        });
        Object.defineProperty(this, "staffSearchGuardians", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (params) => {
                const token = authService.getToken();
                if (!token)
                    throw new Error("No hay token de autenticación");
                const query = new URLSearchParams({
                    op: "staffSearchGuardians",
                    school_id: params.school_id,
                    year: params.year,
                    q: params.q,
                });
                if (params.limit != null)
                    query.set("limit", String(params.limit));
                if (params.offset != null)
                    query.set("offset", String(params.offset));
                const response = await axios.get(`${this.baseURL}/apoderados?${query.toString()}`, { headers: { Authorization: token } });
                return response.data;
            }
        });
        Object.defineProperty(this, "staffExportGuardians", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (params) => {
                const token = authService.getToken();
                if (!token)
                    throw new Error("No hay token de autenticación");
                const query = new URLSearchParams({
                    op: "staffExportGuardians",
                    school_id: params.school_id,
                    year: params.year,
                });
                const response = await axios.get(`${this.baseURL}/apoderados?${query.toString()}`, { headers: { Authorization: token } });
                return response.data;
            }
        });
        Object.defineProperty(this, "staffValidateUserQr", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (params) => {
                const token = authService.getToken();
                if (!token)
                    throw new Error("No hay token de autenticación");
                const query = new URLSearchParams({
                    op: "staffValidateUserQr",
                    school_id: params.school_id,
                    year: params.year,
                    code: params.code,
                });
                const response = await axios.get(`${this.baseURL}/apoderados?${query.toString()}`, { headers: { Authorization: token } });
                return response.data;
            }
        });
        Object.defineProperty(this, "staffValidateNationalId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (params) => {
                const token = authService.getToken();
                if (!token)
                    throw new Error("No hay token de autenticación");
                const query = new URLSearchParams({
                    op: "staffValidateNationalId",
                    school_id: params.school_id,
                    year: params.year,
                });
                if (params.rut)
                    query.set("rut", params.rut);
                if (params.name)
                    query.set("name", params.name);
                if (params.serial)
                    query.set("serial", params.serial);
                if (params.document_type)
                    query.set("document_type", params.document_type);
                if (params.email)
                    query.set("email", params.email);
                if (params.country_code)
                    query.set("country_code", params.country_code);
                const response = await axios.get(`${this.baseURL}/apoderados?${query.toString()}`, { headers: { Authorization: token } });
                return response.data;
            }
        });
        Object.defineProperty(this, "staffGetGuardianProfile", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (params) => {
                const token = authService.getToken();
                if (!token)
                    throw new Error("No hay token de autenticación");
                const query = new URLSearchParams({
                    op: "staffGetGuardianProfile",
                    school_id: params.school_id,
                    year: params.year,
                    email: params.email,
                });
                const response = await axios.get(`${this.baseURL}/apoderados?${query.toString()}`, { headers: { Authorization: token } });
                return response.data.user;
            }
        });
        Object.defineProperty(this, "staffGetUserDocument", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (params) => {
                const token = authService.getToken();
                if (!token)
                    throw new Error("No hay token de autenticación");
                const query = new URLSearchParams({
                    op: "staffGetUserDocument",
                    school_id: params.school_id,
                    year: params.year,
                    email: params.email,
                    type: params.type,
                });
                const response = await axios.get(`${this.baseURL}/apoderados?${query.toString()}`, { headers: { Authorization: token } });
                return response.data;
            }
        });
        Object.defineProperty(this, "staffListQrAccessLogs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (params) => {
                const token = authService.getToken();
                if (!token)
                    throw new Error("No hay token de autenticación");
                const query = new URLSearchParams({
                    op: "staffListQrAccessLogs",
                    school_id: params.school_id,
                    year: params.year,
                    from: params.from,
                    to: params.to,
                });
                if (params.limit != null)
                    query.set("limit", String(params.limit));
                if (params.cursor)
                    query.set("cursor", params.cursor);
                const response = await axios.get(`${this.baseURL}/apoderados?${query.toString()}`, { headers: { Authorization: token } });
                return response.data;
            }
        });
        Object.defineProperty(this, "staffExportQrAccessLogs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (params) => {
                const token = authService.getToken();
                if (!token)
                    throw new Error("No hay token de autenticación");
                const query = new URLSearchParams({
                    op: "staffExportQrAccessLogs",
                    school_id: params.school_id,
                    year: params.year,
                    from: params.from,
                    to: params.to,
                });
                const response = await axios.get(`${this.baseURL}/apoderados?${query.toString()}`, { headers: { Authorization: token } });
                return response.data;
            }
        });
        // Función para ofuscar email
        Object.defineProperty(this, "maskEmail", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (email) => {
                if (!email || !email.includes("@"))
                    return email;
                const [localPart, domain] = email.split("@");
                let maskedLocal;
                if (localPart.length <= 3) {
                    maskedLocal = localPart;
                }
                else if (localPart.length <= 6) {
                    maskedLocal =
                        localPart.substring(0, 2) +
                            "*".repeat(localPart.length - 3) +
                            localPart.charAt(localPart.length - 1);
                }
                else {
                    maskedLocal =
                        localPart.substring(0, 3) +
                            "*".repeat(localPart.length - 5) +
                            localPart.substring(localPart.length - 2);
                }
                let maskedDomain;
                if (domain.length <= 8) {
                    maskedDomain = domain;
                }
                else {
                    const domainParts = domain.split(".");
                    if (domainParts.length >= 2) {
                        const mainDomain = domainParts[0];
                        const extension = domainParts.slice(1).join(".");
                        let maskedMainDomain;
                        if (mainDomain.length <= 4) {
                            maskedMainDomain = mainDomain;
                        }
                        else {
                            maskedMainDomain =
                                mainDomain.substring(0, 2) +
                                    "*".repeat(mainDomain.length - 3) +
                                    mainDomain.charAt(mainDomain.length - 1);
                        }
                        maskedDomain = `${maskedMainDomain}.${extension}`;
                    }
                    else {
                        maskedDomain =
                            domain.substring(0, 2) +
                                "*".repeat(domain.length - 3) +
                                domain.charAt(domain.length - 1);
                    }
                }
                return `${maskedLocal}@${maskedDomain}`;
            }
        });
        // Función para revelar email completo
        Object.defineProperty(this, "unmaskEmail", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (email) => {
                return email;
            }
        });
        this.baseURL = "https://front.microcentrum.cl/v1";
    }
}
export const apoderadosService = new ApoderadosService();
